<template lang="pug">
fragment
  div
    .m-form-field
      .subttl
        strong ＜事前アンケート＞
        span 映像制作についてのアンケートにお答えください
      .m-form-label.is-required
        | 本ウェビナーに申し込んだきっかけを上位3つまで教えてください
      validation-provider(:rules="{ required: true, maxCount: 3 }" name="本ウェビナーに申し込んだきっかけ" v-slot="{ errors, invalid, validated }")
        .m-form-col.theme-col-1(:class="{ 'is-error': invalid && validated }")
          .m-checkbox(v-for="(opportunity, i) in opportunities" :key="i")
            input(type="checkbox" v-model="enquete.opportunities" :value="opportunity" :id="`opportunity-${i}`")
            label(:for="`opportunity-${i}`")
              | {{ opportunity }}
              .other(v-if="opportunity === 'その他'")
                validation-provider(:rules="{ required: isOtherRequired(`opportunity-${i}`) }" v-slot="{ invalid }")
                  input(type="text" v-model="enquete.opportunities_other" :class="{ 'is-error': isOtherRequired(`opportunity-${i}`) && !enquete.opportunities_other && !errors[0] }" :disabled="!isOtherRequired(`opportunity-${i}`)")
                  //- エラーに気付きづらいため、選択直後からエラーが表示されるようにする
                  .error-message(v-if="isOtherRequired(`opportunity-${i}`) && !enquete.opportunities_other && !errors[0]") 必須項目です。
        .error-message(v-if="validated && errors[0]" v-html="errors[0]")

    .m-form-field
      .m-form-label.is-required
        | 縦型動画コンテスト「Vertical Movie Award」を知っていますか？
      validation-provider(rules="required" name="縦型動画コンテスト「Vertical Movie Award」を知っていますか" v-slot="{ errors, invalid, validated }")
        .m-form-col.theme-col-2(:class="{ 'is-error': invalid && validated }")
          .m-radio(v-for="(yn, i) in yesNo" :key="i")
            input(type="radio" v-model="enquete.know_vertical_award" :value="yn" :id="`knowVerticalAward-${i}`")
            label(:for="`knowVerticalAward-${i}`")
              | {{ yn }}
        .error-message(v-if="validated && errors[0]" v-html="errors[0]")

    .m-form-field(v-if="enquete.know_vertical_award === 'はい'")
      .m-form-label.is-required
        | 縦型動画コンテスト「Vertical Movie Award」を知ったキッカケを教えてください(上記設問ではいと答えた方のみ)
      validation-provider(:rules="{ required: enquete.know_vertical_award === 'はい' }" name="縦型動画コンテスト「Vertical Movie Award」を知ったキッカケを教えてください(Q2ではいと答えた方のみ)" v-slot="{ errors, invalid, validated }")
        .m-form-col.theme-col-pc-2(:class="{ 'is-error': invalid && validated }")
          .m-radio(v-for="(knewOpportunity, i) in knewOpportunities" :key="i")
            input(type="radio" v-model="enquete.knew_opportunity" :value="knewOpportunity" :id="`knewOpportunity-${i}`")
            label(:for="`knewOpportunity-${i}`")
              | {{ knewOpportunity }}
              .other(v-if="knewOpportunity === 'その他'")
                validation-provider(:rules="{ required: isOtherRequired(`knewOpportunity-${i}`) }" v-slot="{ invalid }")
                  input(type="text" v-model="enquete.knew_opportunity_other" :class="{ 'is-error': isOtherRequired(`knewOpportunity-${i}`) && !enquete.knew_opportunity_other && !errors[0] }" :disabled="!isOtherRequired(`knewOpportunity-${i}`)")
                  //- エラーに気付きづらいため、選択直後からエラーが表示されるようにする
                  .error-message(v-if="isOtherRequired(`knewOpportunity-${i}`) && !enquete.knew_opportunity_other && !errors[0]") 必須項目です
        .error-message(v-if="validated && errors[0]" v-html="errors[0]")

    .m-form-field
      .m-form-label.is-required
        | 縦型動画コンテスト「Vertical Movie Award」に応募しようとおもっていますか？
      validation-provider(rules="required" name="縦型動画コンテスト「Vertical Movie Award」に応募しようとおもっていますか" v-slot="{ errors, invalid, validated }")
        .m-form-col.theme-col-2(:class="{ 'is-error': invalid && validated }")
          .m-radio(v-for="(yn, i) in yesNo" :key="i")
            input(type="radio" v-model="enquete.apply_vertical_award" :value="yn" :id="`applyVerticalAward-${i}`")
            label(:for="`applyVerticalAward-${i}`")
              | {{ yn }}
        .error-message(v-if="validated && errors[0]" v-html="errors[0]")

    .m-form-field
      .m-form-label.is-required
        | 普段使われているカメラ機材について教えてください
      validation-provider(rules="required" name="普段使われているカメラ機材" v-slot="{ errors, invalid, validated }")
        .m-form-col.theme-col-1(:class="{ 'is-error': invalid && validated }")
          .m-radio(v-for="(cameraType, i) in cameraTypes" :key="i")
            input(type="radio" v-model="enquete.camera_type" :value="cameraType" :id="`cameraType-${i}`")
            label(:for="`cameraType-${i}`")
              | {{ cameraType }}
              .other(v-if="cameraType === 'その他'")
                validation-provider(:rules="{ required: isOtherRequired(`cameraType-${i}`) }" v-slot="{ invalid }")
                  input(type="text" v-model="enquete.camera_type_other" :class="{ 'is-error': isOtherRequired(`cameraType-${i}`) && !enquete.camera_type_other && !errors[0] }" :disabled="!isOtherRequired(`cameraType-${i}`)")
                  //- エラーに気付きづらいため、選択直後からエラーが表示されるようにする
                  .error-message(v-if="isOtherRequired(`cameraType-${i}`) && !enquete.camera_type_other && !errors[0]") 必須項目です
        .error-message(v-if="validated && errors[0]" v-html="errors[0]")

    .m-form-field
      .m-form-label.is-optional
        label(for="questions") 登壇者への質問がありましたら記載してください
      validation-provider(name="登壇者への質問がありましたら記載してください" v-slot="{ errors, invalid, validated }")
        div(:class="{ 'checkbox-error': invalid && validated }")
          textarea(id="questions" v-model="enquete.questions")
        .error-message(v-if="validated && errors[0]" v-html="errors[0]")

</template>

<script>
import { Fragment } from 'vue-fragment'
import FormTextInput from '~/components/FormTextInput'
import FormTextarea from '~/components/FormTextarea'

const OPPORTUNITIES = [
  'Vertical Movie Awardに応募しようと思っているから',
  '許諾・権利関係について学びたいから',
  '企業案件のノウハウを学びたいから',
  '撮影における注意点・ルールについて学びたいから',
  '無料だから',
  'その他'
]

const YES_NO = ['はい', 'いいえ']

const KNEW_OPPORTUNITIES = [
  'NikonのX(旧Twitter)',
  'NikonのInstagram',
  'NikonのYouTube',
  'NikonのLINE',
  'NikonのHP',
  'Nikonのメルマガ',
  'VookのSNS',
  'VookのHP',
  'Vookのメルマガ',
  'SNS広告（X 旧Twitter）',
  'SNS広告（Instagram）',
  'SNS広告（YouTube）',
  '登竜門',
  'Webメディア',
  'その他'
]

const CAMERA_TYPES = [
  'Nikon Z 9',
  'Nikon Z 8',
  'Nikon Z 7II',
  'Nikon Z 6II',
  'Nikon Z 7',
  'Nikon Z 6',
  'Nikon Z 5',
  'Nikon Z f',
  'Nikon Z 50',
  'Nikon Z 30',
  'Nikon Z fc',
  'Nikon Zシリーズ以外',
  'パナソニック LUMIX G9PROII',
  'パナソニック LUMIX G9',
  'パナソニック LUMIX GH6',
  'パナソニック LUMIX GH5',
  'パナソニック LUMIX GH5 II',
  'パナソニック LUMIX GH5S',
  'パナソニック LUMIX S1R',
  'パナソニック LUMIX G100',
  'パナソニック LUMIX S1',
  'パナソニック LUMIX S5II',
  '​パナソニック LUMIX S5IIx',
  'パナソニック LUMIX S5',
  'パナソニック LUMIX S1H',
  'パナソニック LUMIX BS1H',
  'パナソニック LUMIX BGH1',
  'その他のパナソニックのカメラ',
  'ソニー α1',
  'ソニー α9 II',
  'ソニー α7R V',
  'ソニー α7R IV',
  'ソニー α7R III',
  'ソニー α7S III',
  'ソニー α7 IV',
  'ソニー α7 III',
  'ソニー α7CR',
  'ソニー α7CII',
  'ソニー α7C',
  'ソニー α6700',
  'ソニー α6600',
  'ソニー VENICE 2 8K',
  'ソニー VENICE 2 6K',
  'ソニー VENICE',
  'ソニー FX9',
  'ソニー FX6',
  'ソニー FX3',
  'ソニー FX30',
  'ソニー VLOGCAM ZV-1 F',
  'ソニー VLOGCAM ZV-1 II',
  'ソニー VLOGCAM ZV-1',
  'ソニー VLOGCAM ZV-E1/E1L',
  'ソニー VLOGCAM ZV-E10',
  'その他のソニーのカメラ',
  'キヤノン EOS R3',
  'キヤノン EOS R5',
  'キヤノン EOS R5 C',
  'キヤノン EOS R6',
  'キヤノン EOS R6 Mark II',
  'キヤノン EOS Rシリーズ（その他）',
  'キヤノン EOS 5Dシリーズ',
  'キヤノン CINEMA EOS SYSTEM C70',
  'キヤノン CINEMA EOSシリーズ（その他）',
  'その他のキヤノンDSLR／ミラーレスカメラ',
  'フジフイルム GFX シリーズ',
  'フジフイルム X-H シリーズ',
  'フジフイルム X-T シリーズ',
  'その他のフジフイルムのカメラ',
  'OM SYSTEM OM-Dシリーズのカメラ',
  'その他のOM SYSTEMのカメラ',
  'ブラックマジックデザイン Blackmagic Pocket Cinema Camera 6K Pro',
  'ブラックマジックデザイン Blackmagic Pocket Cinema Camera 6K',
  'ブラックマジックデザイン Blackmagic Pocket Cinema Camera 4K',
  'その他のブラックマジックデザインのカメラ',
  'SIGMA fp L',
  'RED KOMODO 4K／6K',
  'ARRI ALEXA Mini',
  'その他'
]

export default {
  components: {
    FormTextInput,
    FormTextarea,
    Fragment
  },
  data() {
    return {
      enquete: {
        opportunities: [],
        opportunities_other: null,
        know_vertical_award: null,
        apply_vertical_award: null,
        knew_opportunity: null,
        knew_opportunity_other: null,
        camera_type: null,
        camera_type_other: null,
        questions: null
      }
    }
  },
  computed: {
    opportunities() {
      return OPPORTUNITIES
    },
    yesNo() {
      return YES_NO
    },
    knewOpportunities() {
      return KNEW_OPPORTUNITIES
    },
    cameraTypes() {
      return CAMERA_TYPES
    }
  },
  watch: {
    'enquete.opportunities': {
      handler() {
        if (this.enquete.opportunities !== 'その他') {
          this.enquete.opportunities_other = null
        }
        this.$cookies.set('entryEventEnquete', this.enquete)
      }
    },
    'enquete.know_vertical_award': {
      handler() {
        this.$cookies.set('entryEventEnquete', this.enquete)
      }
    },
    'enquete.apply_vertical_award': {
      handler() {
        this.$cookies.set('entryEventEnquete', this.enquete)
      }
    },
    'enquete.knew_opportunity': {
      handler() {
        if (this.enquete.knew_opportunity !== 'その他') {
          this.enquete.knew_opportunity_other = null
        }
        this.$cookies.set('entryEventEnquete', this.enquete)
      }
    },
    'enquete.camera_type': {
      handler() {
        if (this.enquete.camera_type !== 'その他') {
          this.enquete.camera_type_other = null
        }
        this.$cookies.set('entryEventEnquete', this.enquete)
      }
    },
    'enquete.questions': {
      handler() {
        this.$cookies.set('entryEventEnquete', this.enquete)
      }
    }
  },
  mounted() {
    const enqueteCookie = this.$cookies.get('entryEventEnquete')
    if (enqueteCookie) {
      this.enquete = enqueteCookie
    }
  },
  methods: {
    isOtherRequired(id) {
      if (process.browser) {
        const element = document.getElementById(id)
        if (element) {
          return element.checked
        }
      } else {
        return false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.subttl {
  background: #eee;
  @include media(pc) {
    display: flex;
    justify-content: center;
    padding: 20px;
    margin-bottom: 40px;
    font-size: 1.4em;
  }
  @include media(sp) {
    margin: 0 -10px 20px;
    padding: 10px;
    line-height: 1.4;
    text-align: center;
  }
  strong {
    font-weight: bold;
    @include media(pc) {
      margin-right: 10px;
    }
    @include media(sp) {
      display: block;
    }
  }
}
</style>
